import React from 'react';
import styles from '../styles/LoadingScreen.module.css';
import { useUiCopy } from '../i18n/useUiCopy';

interface LoadingScreenProps {
  visible: boolean;
  message: string;
  progress: number;
  jobTitle?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ visible, message, progress, jobTitle }) => {
  const copy = useUiCopy();
  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <img src="/isa_portrait.png" alt="ISA Portrait" className={styles.logo} />
        <h1 className={styles.title}>ISA</h1>
        <p className={styles.subtitle}>{copy.productTitle.replace(/^ISA - /, "")}</p>

        {jobTitle && (
            <p className={styles.jobTitle}>
                {copy.preparingRole("\u0000").split("\u0000")[0]}
                <strong>{jobTitle}</strong>
                {copy.preparingRole("\u0000").split("\u0000")[1]}
            </p>
        )}

        <div className={styles.statusBox}>
            <div className={styles.spinner}></div>
            <p className={styles.statusMessage} aria-live="polite">
                {message || copy.initializing}
            </p>
        </div>

        <div className={styles.progressBarContainer}>
          <div
            className={styles.progressBar}
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
